import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  to: string;
  children: ReactNode;
  variant?: 'dark' | 'light' | 'outline';
  size?: 'sm' | 'md';
}

const variants = {
  dark: 'bg-primary-500 text-background-50 hover:bg-primary-600',
  light: 'bg-background-100 text-foreground-950 hover:bg-background-200',
  outline: 'border border-foreground-950/20 text-foreground-950 hover:bg-foreground-950 hover:text-background-50',
};

export default function PillLink({ to, children, variant = 'dark', size = 'md' }: Props) {
  const sz = size === 'sm' ? 'h-9 px-5 text-[13px]' : 'h-12 px-7 text-[15px]';
  return (
    <Link
      to={to}
      className={`inline-flex items-center justify-center gap-2 rounded-full font-medium whitespace-nowrap cursor-pointer transition-[background-color,color,transform] duration-200 ease-[cubic-bezier(0.22,1,0.36,1)] motion-safe:hover:-translate-y-0.5 active:translate-y-0 active:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500 ${sz} ${variants[variant]}`}
    >
      {children}
    </Link>
  );
}